import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { BucketResponseResource } from "./bucket-response-resource";
import { MetricOptionResponseResource } from "./metric-option-response-resource";

@JsonObject()
export class AggregationResponseResource {
    @JsonProperty("number_count")
    numberCount: number;

    @JsonProperty("buckets")
    @JsonElementType(BucketResponseResource)
    buckets: Array<BucketResponseResource> = [];

    @JsonProperty("aggregation_type")
    requestedAggregationType: string;

    @JsonProperty("metric_option")
    metricOption: MetricOptionResponseResource;
}
